import { axiosClient } from "../utils";
import { ManageErrorApiResponse, ManageErrorResponse } from "../services";

export const authService = {
  signUp: async (data: SignUpDto): Promise<SignUpResponse> => {
    const res = await axiosClient.post<SignUpResponse>("/create-account", data);

    return res.data;
  },

  signIn: async (data: SignInDto): Promise<SignInResponse> => {
    try {
      const req = await axiosClient.post("/login", data);
      const token = req.headers["authorization"];
      if (typeof token !== "string") {
        throw new Error(JSON.stringify({ error: "There was an error" }));
      }
      return { token, success: Boolean(req.data.success && token) };
    } catch (error) {
      console.log(error);
      const errorManage = (error as any).response
        .data as ManageErrorApiResponse;
      return { success: false, errorKey: errorManage["field-error"][1] };
    }
  },

  oauthGoogleAuthorize: async (oauthAuthorizeDto: OauthAuthorizeDto): Promise<OauthAuthorizeResponse> => {
    try {
      const {
        action,
        redirect_uri = window.location.origin + "/auth/google/callback" 
      } = oauthAuthorizeDto;
      const res = await axiosClient.post("/auth/google", { action, redirect_uri });
      const authorize_url = res.data.authorize_url;

      return { authorize_url, success: Boolean(authorize_url) };
    } catch (error) {
      console.log(error);
      const errorManage = (error as any).response
        .data as ManageErrorApiResponse;
      return { success: false, errorKey: errorManage["error"] }
    }
  },

  oauthGoogleToken: async (code: string): Promise<OauthTokenResponse> => {
    try {
      const redirect_uri = window.location.origin + "/auth/google/callback"
      const res = await axiosClient.get(`/auth/google/callback`, { params: { code, redirect_uri } });
      const token = res.headers["authorization"];
  
      return { token, success: Boolean(res.data.success && token) };
    } catch (error) {
      console.log(error);
      const errorManage = (error as any).response
        .data as ManageErrorApiResponse;
      return { success: false, errorKey: errorManage["error"] };
    }
  },
};

export interface SignInDto {
  login: string;
  password: string;
}

export interface SignInResponse extends ManageErrorResponse {
  token?: string;
  success: boolean;
}

export interface SignUpDto {
  login: string;
  password: string;
  "password-confirm": string;
  profile: {
    first_name: string;
    last_name: string;
    cellphone: string;
  };
  broker: {
    name: string;
    subdomain: string;
    email: string;
  };
}

export interface SignUpResponse extends ManageErrorResponse {
  data?: {
    id: string;
    type: string;
    attributes: {
      email: string;
      role: string;
      status: number;
    };
    relationships: {
      broker: {
        data: null | any;
      };
      profile: {
        data: {
          id: string;
          type: string;
        };
      };
    };
  };
  included?: any[];
}

export interface OauthAuthorizeDto {
  action: "login" | "signup";
  redirect_uri?: string;
}

export interface OauthAuthorizeResponse extends ManageErrorResponse {
  authorize_url?: string;
  success: boolean;
}

export interface OauthTokenResponse extends ManageErrorResponse {
  token?: string;
  success: boolean;
}